import React, { useState } from 'react';
import { motion } from 'framer-motion';

const GlobalLocationsSection = () => {
  const [activeTab, setActiveTab] = useState('us');

  const tabStyle = (tab) => ({
    cursor: 'pointer',
    fontWeight: '700',
    fontSize: '20px',
    padding: '10px 20px',
    borderBottom: activeTab === tab ? '3px solid #F26522' : 'none',
    color: activeTab === tab ? '#F26522' : '#000',
    transition: 'all 0.3s ease'
  });

  const fadeSlide = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <motion.section
      style={{ padding: '60px 5%', fontFamily: "'Poppins', sans-serif" }}
      variants={fadeSlide}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <h2 style={{ fontSize: '36px', fontWeight: 'bold', textAlign: 'center' }}>Global Locations</h2>
      <hr style={{ width: '80px', margin: '12px auto 40px', border: '2px solid #000' }} />

      <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', marginBottom: '40px' }}>
        <div onClick={() => setActiveTab('us')} style={tabStyle('us')}>US</div>
        <div onClick={() => setActiveTab('india')} style={tabStyle('india')}>India</div>
      </div>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '40px',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        <motion.div
          style={{ flex: '1 1 500px', minWidth: '300px' }}
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {activeTab === 'us' ? (
            <iframe
              title="US Office"
              src="https://www.google.com/maps?q=Five+Greentree+Centre+525+Route+73+North+Suite+104+Marlton+NJ+08053&output=embed"
              width="100%"
              height="350"
              style={{ border: 0, borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          ) : (
            <iframe
              title="India Office"
              src="https://www.google.com/maps?q=DLF+Forum,+Cybercity,+Phase+III,+Gurugram,+Haryana+122002&output=embed"
              width="100%"
              height="350"
              style={{ border: 0, borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          )}
        </motion.div>

        <motion.div
          style={{ flex: '1 1 450px', minWidth: '280px' }}
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
        >
          {activeTab === 'us' ? (
            <>
              <h3 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '10px' }}>
                US Office – MDERCM Solutions LLC
              </h3>
              <p><strong>Address:</strong><br />
                Five Greentree Centre<br />
                525 Route 73 North, Suite 104<br />
                Marlton, NJ 08053, USA
              </p>
              <p>
                <a href="https://www.google.com/maps?q=Five+Greentree+Centre+525+Route+73+North+Suite+104+Marlton+NJ+08053"
                  target="_blank" rel="noopener noreferrer"
                  style={{ color: '#F26522', fontWeight: 'bold' }}>
                  View on Google Map &gt;
                </a>
              </p>
              <p><strong>Phone:</strong> +1 (510) 356-6069</p>
              <p><strong>Authorized Representatives:</strong><br />Poonam Kapoor & Rishi Kapoor</p>
              <p>
                <a href="mailto:info@us-office.com" style={{ color: '#F26522' }}>
                  Email the US office &gt;
                </a>
              </p>
            </>
          ) : (
            <>
              <h3 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '10px' }}>
                India Office – MDeRCM
              </h3>
              <p><strong>Address:</strong><br />
                DLF Forum, Cybercity, Phase III<br />
                Gurugram, Haryana 122002, India
              </p>
              <p>
                <a href="https://www.google.com/maps?q=DLF+Forum,+Cybercity,+Phase+III,+Gurugram,+Haryana+122002"
                  target="_blank" rel="noopener noreferrer"
                  style={{ color: '#F26522', fontWeight: 'bold' }}>
                  View on Google Map &gt;
                </a>
              </p>
              <p><strong>Phone:</strong> +91-9311250055</p>
              <p>
                <a href="mailto:info@india-office.com" style={{ color: '#F26522' }}>
                  Email the India office &gt;
                </a>
              </p>
            </>
          )}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default GlobalLocationsSection;